import isNumber from 'lodash/isNumber';
import { getDateWithCapitalLetterMonth, prepareDateRangeText } from '@yme/utils/common';
import { LIMIT_TEMPLATE, NEWS_PAGE_ENDPOINT_TEMPLATE, OFFSET_TEMPLATE, PARAMS_KEYS, TYPE_TEMPLATE, } from './constants';
export const getCategoriesTitleList = (categories) => categories.map((category) => category.title);
export const getSelectedCategoryList = (categoryList, categoriesTitle) => categoryList
    ?.filter((category) => categoriesTitle?.includes(category.title))
    .map((item) => item.value);
export const getYearsList = (startYear) => {
    const currentYear = new Date().getFullYear();
    const range = currentYear - startYear + 1;
    return Array.from({
        length: range,
    }, (_, i) => `${startYear + i}`).reverse();
};
export const buildRequest = ({ categories, years, offset = 0, limit = 18, pagePath, type, }) => {
    const yearsParams = years?.length && `,${PARAMS_KEYS.years}:["${years.join('","')}"]`;
    const categoriesParams = categories?.length && `,${PARAMS_KEYS.categories}:["${categories?.join('","')}"]`;
    const dataParams = `&data={"pagePath":"${pagePath}"${yearsParams || ''}${categoriesParams || ''}}`;
    let defaultRequest = NEWS_PAGE_ENDPOINT_TEMPLATE.replace(TYPE_TEMPLATE, type)
        .replace(OFFSET_TEMPLATE, `${offset}`)
        .replace(LIMIT_TEMPLATE, `${limit}`);
    defaultRequest += dataParams;
    return defaultRequest;
};
const getTitleFromValues = (values, options) => {
    const titleArr = [];
    options?.forEach((option) => {
        if (values.includes(option.value)) {
            titleArr.push(option.title);
        }
    });
    return titleArr;
};
export const buildDataFromURL = (search, labels, categories) => {
    const params = new URLSearchParams(search);
    const filters = {};
    params.forEach((value, key) => {
        if (key === PARAMS_KEYS.categories) {
            const categoriesValues = getTitleFromValues(value.split(','), categories);
            filters[key] = {
                name: labels.newsEventsGrid_category_label,
                value: categoriesValues,
            };
        }
        if (key === PARAMS_KEYS.years) {
            filters[key] = {
                name: labels.newsGrid_yearFilter_label,
                value: value.split(','),
            };
        }
        if (key === PARAMS_KEYS.page) {
            filters[key] = Number(value);
        }
    });
    return filters;
};
export const getEmptyArrayData = (total, limit) => total && limit ? Math.ceil(total / limit) : 1;
export const getOffset = (page, limit) => {
    const offset = (page - 1) * limit;
    if (Number.isNaN(offset) || offset < 0) {
        return 0;
    }
    return offset;
};
export const getURLWithFilters = ({ years, categories, page }) => {
    const params = new URLSearchParams(isNumber(page) ? `${PARAMS_KEYS.page}=${page}` : '');
    if (years?.length) {
        const yearsString = years.join(',');
        params.set(PARAMS_KEYS.years, yearsString);
    }
    if (categories?.length) {
        const categoriesString = categories.join(',');
        params.set(PARAMS_KEYS.categories, categoriesString);
    }
    return `?${params.toString()}`;
};
export const getDataForMobileFilters = (data) => data.filter((item) => Boolean(item?.name));
export const getDataForFilter = (filteredArray, filterType, filterTitles) => {
    const filterData = filterType === 'years' ? filteredArray?.years : filteredArray?.categories;
    return filterTitles?.map((filterTitle) => ({
        label: filterTitle,
        value: filterTitle,
        checked: filterData?.value.includes(filterTitle) || false,
    }));
};
export const getCardCaption = (article, language) => {
    const { dateTo, dateFrom, date } = article;
    if (date) {
        const formatted = new Intl.DateTimeFormat(language, {
            month: 'long',
            year: 'numeric',
            day: 'numeric',
        });
        const newsDate = new Date(date);
        return getDateWithCapitalLetterMonth(formatted, newsDate);
    }
    if (dateTo && dateFrom) {
        return prepareDateRangeText({
            dateFrom,
            dateTo,
            lang: language,
            hasTime: false,
        });
    }
    return undefined;
};
export function generateYearsArray(backYears) {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < backYears; i++) {
        years.push(String(currentYear - i));
    }
    return years;
}
